import BoothList from './BoothList.vue'
import Chip from './Chip.vue'
import Footer from './Footer.vue'
import FragmentList from './FragmentList.vue'
import Header from './Header.vue'
import QrcodeReader from './QRScanner.vue'
import SquareGrid from './SquareGrid.vue'
import Snackbar from './Snackbar.vue'

export default {
  BoothList,
  Chip,
  Footer,
  FragmentList,
  Header,
  QrcodeReader,
  SquareGrid,
  Snackbar
}
